import styled from 'styled-components'
import { themeColor, Flex, Box, Selector } from '@elparking/components'

export const PlaceSelectorContainer = styled(Flex)`
    border: 1px solid ${themeColor('gray20')};
    border-radius: 2px;
    background-color: ${themeColor('white')};
    position: relative;
    border-radius: 0px 0px 2px 2px;
    border-radius: 2px 2px 0px 0px;
`

export const VehicleTypeContainer = styled(Flex)`
    border: 1px solid ${themeColor('gray20')};
    border-top: 0px;
    border-radius: 2px;
    background-color: ${themeColor('white')};
    position: relative;
    margin-bottom: 0;
    border-radius: 0px 0px 2px 2px;
`

export const SeparatorBox = styled(Box)`
    height: 100%;
    border-left: 1px solid ${themeColor('gray20')};
    margin-left: -1px;
`

export const VehicleTypeSelectorContainer = styled(Selector)`
    border: 0;
    background: ${themeColor('white')};
    box-shadow: none;
`
